import { Theme, } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      padding: '12px',
      maxWidth: '500px'
    }
  }
});

export default useStyles;
